<template>
  <div>
    <md-dialog
      class="action-settings-detail-dialog"
      :md-active="mdActive"
      @update:mdActive="closeDialog()"
      @md-opened="initDialog()">
      <md-dialog-content v-if="dataLoaded">
        <md-empty-state
          v-if="message.isDisplayed"
          md-icon="warning"
          :md-label="message.label"
          :md-description="message.description" />
        <form class="action-settings-form">
          <span
            class="md-title"
            :title="data.id">Détails du paramètre d'action</span>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Action (non modifiable)</label>
                <md-input
                  v-model="data.action.label"
                  readonly />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Nom du paramètre</label>
                <md-input
                  v-model="data.label"
                  :disabled="!data.is_user_defined" />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Description</label>
                <md-textarea
                  md-counter="500"
                  v-model="data.comment" />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <md-checkbox
                v-model="data.action.changes_energy"
                class="md-primary"
                :disabled="!data.is_user_defined">Changement d'énergie</md-checkbox>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <h2>Effet sur les usages</h2>
              <div class="md-card md-table md-theme-default usage-table dialog-tables-margin">
                <div class="md-table-content md-theme-default">
                  <table>
                    <thead>
                      <tr>
                        <th class="md-table-head">
                          <div class="md-table-head-container">
                            <div class="md-table-head-label">
                              Usage
                            </div>
                          </div>
                        </th>
                        <th
                          v-for="actionUse in data.action_use"
                          :key="`actionuseheader_${actionUse.id}`"
                          class="md-table-head">
                          <div class="md-table-head-container">
                            <div class="md-table-head-label">
                              {{ actionUse.label }}
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="md-table-row">
                        <td class="md-table-cell">
                          <div class="md-table-cell-container">Valeur</div>
                        </td>
                        <td
                          class="md-table-cell"
                          :key="`actionusevalue_${actionUse.id}`"
                          v-for="actionUse in data.action_use">
                          <div class="md-table-cell-container">
                            <target-values-inline-list
                              v-if="actionUse.is_default_value"
                              :display-value="getFormatedValue(actionUse.value)"
                              :target-values="actionUse.target_values"
                              :show-unit="false" />
                            <md-field v-if="!actionUse.is_default_value">
                              <md-input
                                type="number"
                                step="0.1"
                                :value="actionUse.value"
                                @input="actionUse.value = $event"
                                :placeholder="'\u2205'"
                                :disabled="!data.is_user_defined" />
                            </md-field>
                          </div>
                        </td>
                      </tr>
                      <tr class="md-table-row">
                        <td class="md-table-cell">
                          <div class="md-table-cell-container">Unité</div>
                        </td>
                        <td
                          class="md-table-cell"
                          :key="`actionuseunit_${actionUse.id}`"
                          v-for="actionUse in data.action_use">
                          <div class="md-table-cell-container">
                            <span
                              class="md-suffix"
                              v-html="splitUnit(actionUse.unit)[0]" />
                            <div v-html="splitUnit(actionUse.unit)[1]" />
                          </div>
                        </td>
                      </tr>

                      <tr class="md-table-row">
                        <td class="md-table-cell">
                          <div class="md-table-cell-container">Valeur cible standard</div>
                        </td>
                        <td
                          class="md-table-cell"
                          :key="`actionuseuserdefined_${actionUse.id}`"
                          v-for="actionUse in data.action_use">
                          <div class="md-table-cell-container">
                            <md-checkbox
                              :model="actionUse.is_default_value"
                              @change="setDefaultValue(actionUse, $event)"
                              :disabled="!data.is_user_defined" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <h2>Coûts par fonction</h2>
              <md-table
                v-model="data.action_investment"
                md-card
                :class="{ 'dialog-functions-table': true, 'dialog-tables-margin': true }">
                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }">
                  <md-table-cell md-label="Fonctions">{{ item.function }}</md-table-cell>
                  <md-table-cell md-label="Coût énergie">
                    <md-field>
                      <md-input
                        type="number"
                        step="0.1"
                        class="input-align-right"
                        :value="getRoundedValue(item.energy_investment)"
                        @input="item.energy_investment = $event"
                        :disabled="!data.is_user_defined" />
                      <span
                        class="md-suffix"
                        v-html="item.unit" />
                    </md-field>
                  </md-table-cell>
                  <md-table-cell md-label="Coût total">
                    <md-field>
                      <md-input
                        type="number"
                        step="0.1"
                        class="input-align-right"
                        :value="getRoundedValue(item.total_investment)"
                        @input="item.total_investment = $event"
                        :disabled="!data.is_user_defined" />
                      <span
                        class="md-suffix"
                        v-html="item.unit" />
                    </md-field>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <h2>Portée de l'action</h2>
              <md-radio
                v-model="data.is_general"
                :value="true"
                :disabled="!data.is_user_defined">Action générale</md-radio>
              <md-radio
                v-model="data.is_general"
                :value="false"
                :disabled="!data.is_user_defined">Action sur un lieu</md-radio>
            </div>
          </div>
          <template v-if="data.is_general">
            <md-card>
              <md-card-content>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>Fonction visée</label>
                    <md-select
                      md-dense
                      v-model="data.function"
                      name="function"
                      id="function"
                      :disabled="!data.is_user_defined">
                      <md-option
                        v-for="func in functionsList"
                        :key="func.slug"
                        :value="func.id">
                        {{ func.label }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
              </md-card-content>
            </md-card>
          </template>
          <template v-if="!data.is_general">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-100">
                <places-table
                  :places-type="data.action.place_type"
                  :selected-places.sync="data.places"
                  :disabled-places="data.disabled_places"
                  :fields-errors="fieldsErrors"
                  :editable="data.is_user_defined" />
              </div>
            </div>
          </template>
        </form>
      </md-dialog-content>
      <md-dialog-actions class="dialog-actions">
        <div
          class="md-layout"
          v-if="data.is_user_defined">
          <div class="md-layout-item dialog-action-left">
            <md-button
              class="md-accent"
              @click="confirmActionDelete(data)">
              Supprimer
            </md-button>
          </div>
          <div class="md-layout-item dialog-action-right">
            <md-button
              @click="closeDialog">Annuler</md-button>
            <md-button
              class="md-raised md-primary"
              @click="save">Enregistrer</md-button>
          </div>
        </div>
        <div
          class="md-layout"
          v-if="!data.is_user_defined">
          <div class="md-layout-item dialog-action-right">
            <md-button
              class="md-raised md-primary"
              @click="closeDialog">Fermer</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-confirm
      :md-active.sync="deleteConfirmDialog.active"
      md-title="Supprimer le paramètre d'action ?"
      :md-content="deleteConfirmDialog.content"
      md-confirm-text="Supprimer"
      md-cancel-text="Annuler"
      @md-cancel="deleteConfirmDialog.active = false"
      @md-confirm="onDeleteConfirm" />
  </div>
</template>

<script>
import session from '@/api/session'
import PlacesTable from '@/components/PlacesTable.vue'
import TargetValuesInlineList from '@/components/TargetValuesInlineList'
import ValuesDisplayMixin from '@/mixins/ValuesDisplayMixin'

export default {
  name: 'ActionBaseDetailDialog',
  mixins: [ValuesDisplayMixin],
  components: {
    PlacesTable,
    TargetValuesInlineList
  },
  data () {
    return {
      functionsList: [],
      dataLoaded: false,
      data: {
        action: {},
        action_use: [],
        action_investment: [],
        places: [],
        is_general: true,
        is_user_defined: false
      },
      deleteConfirmDialog: {
        active: false,
        actionSettingsId: null,
        content: 'Voulez-vous supprimer définitivement le paramètre d\'action : {label} ?'
      },
      message: {
        isDisplayed: false,
        label: '',
        description: ''
      },
      fieldsErrors: {}
    }
  },
  props: {
    mdActive: {
      type: Boolean,
      default: false
    },
    actionId: {
      type: Number,
      default: null
    }
  },
  methods: {
    initDialog: function () {
      this.fieldsErrors = {}
      this.loadData()
    },
    async loadData () {
      try {
        let actionSettingsResponse = await session.get('/api/actions/settings/' + this.actionId + '/')
        let functionResponse = await session.get('/api/parameters/functions/')

        this.$set(this, 'data', actionSettingsResponse.data)
        this.$set(this, 'functionsList', functionResponse.data)
        this.functionsList.unshift({'id': '', 'label': 'Toutes', 'slug': ''})
        this.dataLoaded = true
        this.$store.dispatch('loading/end_loading')
      } catch (error) {
        const response = error.response
        this.$store.dispatch('loading/end_loading')
        this.closeDialog()
        if (response.status === 500) {
          this.$store.commit('errors/SHOW', {})
        }
      }
    },
    setDefaultValue (actionUse, event) {
      actionUse.is_default_value = event
      actionUse.value = null
      actionUse.improvement_value = null
    },
    async save () {
      let payload = {
        label: this.data.label,
        comment: this.data.comment,
        action_investment: this.data.action_investment,
        action_use: (() => {
          return this.data.action_use.map(item => {
            if (item.is_default_value === true) {
              item.improvement_type = 1 // target_value
            } else if (item.value !== null && item.value !== 0) {
              item.improvement_value = item.value
              if (item.improvement_type === null) {
                item.improvement_type = 1 // we assume that the user can only fill target_value
              }
            } else {
              item.improvement_value = null
            }
            return item
          })
        })()
      }

      if (this.data.is_general === true) {
        payload.function = this.data.function
        payload.places = []
      } else {
        payload.function = null
        payload.places = this.data.places
      }

      this.fieldsErrors = {}

      try {
        await session.patch(`/api/actions/settings/${this.actionId}/`, payload)
        this.$store.commit('messages/SHOW', {
          label: 'Enregistré',
          description: 'Le paramètre d\'action a été enregistré.'
        })
        this.closeDialog()
        this.$emit('reload')
      } catch (error) {
        const response = error.response
        this.$store.dispatch('loading/end_loading')

        if (response.status === 400) {
          let fieldsErrors = response.data
          for (let fieldName in fieldsErrors) {
            this.$set(this.fieldsErrors, fieldName, fieldsErrors[fieldName][0])
          }
        } else {
          this.closeDialog()
          if (response.status === 500) {
            this.$store.commit('errors/SHOW', {})
          }
        }
      }
    },
    closeDialog () {
      this.$emit('update:mdActive', false)
      this.dataLoaded = false
    },
    confirmActionDelete (actionSettings) {
      this.deleteConfirmDialog.content = this.deleteConfirmDialog.content.replace('{label}', actionSettings.label)
      this.deleteConfirmDialog.actionSettingsId = actionSettings.id
      this.deleteConfirmDialog.active = true
    },
    async onDeleteConfirm () {
      this.deleteConfirmDialog.active = false
      this.$store.dispatch('loading/begin_loading')
      const actionSettingsId = this.deleteConfirmDialog.actionSettingsId

      try {
        await session.delete(`/api/actions/settings/${actionSettingsId}/`)
        this.deleteConfirmDialog.actionSettingsId = null
        this.closeDialog()
        this.$emit('reload')
        this.$store.commit('messages/SHOW', {
          label: 'Supprimé',
          description: 'Le paramètre d\'action a été supprimé.'
        })
      } catch (error) {
        const response = error.response
        this.$store.dispatch('loading/end_loading')
        this.closeDialog()
        if (response.status === 500) {
          this.$store.commit('errors/SHOW', {})
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.usage-table {
  .md-input {
    width: 100%;
    min-width: 100%;
  }
}

.input-align-right {
  text-align: right;
}

.action-settings-detail-dialog >>> .md-dialog-container {
  overflow: auto;
}

.action-settings-form {
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/ActionBaseDetailDialog.vue